<button class="btn table-sorting__btn" [ngClass]="getOrderBy()" (click)="baseComponent.orderBy(property)">
	<svg x="0px" y="0px" viewBox="0 0 384 384">
		<g>
			<polygon class="up" points="128,0 42.7,85.1 106.7,85.1 106.7,234.7 149.3,234.7 149.3,85.1 213.3,85.1"/>
			<polygon class="down" points="277.3,298.9 277.3,149.3 234.7,149.3 234.7,298.9 170.7,298.9 256,384 341.3,298.9"/>
		</g>
	</svg>
</button>
